<template>
    <b-modal v-model="modalVisible" id="editMemberTierModal" modal-class="client-details-modal payment-history" centered
      size="lg" hide-footer hide-header-close no-close-on-backdrop>
      <template #modal-header class="modal-header-wrapper">
        <div class="text-center">
          <h6 class="mb-0">Edit Tier</h6>
          <b-button variant="close-btn" class="btn-container" @click="closeModal">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>
      <b-container fluid>
        <div class="row">
          <label><strong>Choose Tier :</strong></label>
          <div class="col-12 mb-3 mt-2 tier-optionwrapper d-flex align-items-center gap-3">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                v-model="tierType" value="IO" />
              <label class="form-check-label" for="flexRadioDefault1">
                IO
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
                v-model="tierType" value="IS" />
              <label class="form-check-label" for="flexRadioDefault2">
                IS
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3"
                v-model="tierType" value="IC" />
              <label class="form-check-label" for="flexRadioDefault3">
                IC
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault4"
                v-model="tierType" value="IF" />
              <label class="form-check-label" for="flexRadioDefault4">
                IF
              </label>
            </div>
          </div>
        </div>
        <div v-if="tierType === 'IS'">
          <div v-if="spouses.length > 0" class="mb-3">
              <div v-for="(sp, index) in spouses" :key="sp.id"
                   class="d-inline-flex me-2  align-items-center gap-2 button_wrapper--blue mb-2">
                <div class="rep_name d-inline-flex">
                  #{{ index + 1 }}
                  {{ sp.firstName }}
                  <template v-if="sp.middleName"> {{ sp.middleName }} </template>
                  {{ sp.lastName }}
                </div>
                <button class="tier-listing-card-button" type="button" @click="editSpouse(index)"><i
                    class="fa fa-pencil"></i></button>
  <!--              <button class="tier-listing-card-button" type="button" @click="removeSpouse(index)"><i-->
  <!--                  class="fa fa-trash"></i></button>-->
              </div>
          </div>
          <form class="tier-formwrapper mb-3" v-if="spouses.length === 0 || editingSpouse">
            <div class="form-titlewrapper">Spouse Detail</div>
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">First Name</label>
                <span class="required-asterisk">*</span>
                <input v-model="newSpouse.firstName" type="text" class="input-field" placeholder="Enter First Name"
                  :rules="{ required: true }" />
              </div>
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">Middle Name</label>
                <input v-model="newSpouse.middleName" type="text" class="input-field" placeholder="Enter Middle Name"
                  :rules="{ required: true }" />
              </div>
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">Last Name</label>
                <span class="required-asterisk">*</span>
                <input v-model="newSpouse.lastName" type="text" class="input-field" placeholder="Enter Last Name"
                  :rules="{ required: true }" />
              </div>
              <div class="col-md-6 col-lg-6 mb-3">
                <label class="label-title">Gender</label>
                <span class="required-asterisk">*</span>
                <select v-model="newSpouse.gender" name="gender" id="gender" class="form-select mt-2"
                  :rules="{ required: true }">
                  <option selected disabled value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <div class="col-md-6 col-lg-6 mb-3">
                <label class="label-title">Date of Birth</label>
                <span class="required-asterisk">*</span>
                <input v-model="newSpouse.dob" type="date" class="input-field" placeholder="Select Date of Birth"
                       :rules="{ required: true }" :max="new Date().toISOString().split('T')[0]" />
              </div>
            </div>
          </form>
        </div>
        <div v-if="tierType === 'IC'">
          <div v-if="children.length > 0" class="mb-3">
              <div v-for="(child, index) in children" :key="child.id"
                class="d-inline-flex align-items-center me-2 gap-2 button_wrapper--blue mb-2">
                <div class="rep_name d-inline-flex">
                  #{{ index + 1 }}
                  {{ child.firstName }}
                  <template v-if="child.middleName"> {{ child.middleName }} </template>
                  {{ child.lastName }}
                </div>
                <button class="tier-listing-card-button" type="button" @click="editChild(index)"><i
                    class="fa fa-pencil"></i></button>
                <button class="tier-listing-card-button" type="button" @click="removeChild(index)"><i
                    class="fa fa-trash"></i></button>
              </div>
          </div>
          <form class="tier-formwrapper mb-3">
            <div class="form-titlewrapper">Child Details</div>
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">First Name</label>
                <span class="required-asterisk">*</span>
                <input v-model="newChild.firstName" type="text" class="input-field" placeholder="Enter First Name"
                  :rules="{ required: true }" />
              </div>
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">Middle Name</label>
                <input v-model="newChild.middleName" type="text" class="input-field" placeholder="Enter Middle Name"
                  :rules="{ required: true }" />
              </div>
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">Last Name</label>
                <span class="required-asterisk">*</span>
                <input v-model="newChild.lastName" type="text" class="input-field" placeholder="Enter Last Name"
                  :rules="{ required: true }" />
              </div>
              <div class="col-md-6 col-lg-6 mb-3">
                <label class="label-title">Gender</label>
                <span class="required-asterisk">*</span>
                <select v-model="newChild.gender" name="gender" id="gender" class="form-select mt-2"
                  :rules="{ required: true }">
                  <option selected disabled value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <div class="col-md-6 col-lg-6 mb-3">
                <label class="label-title">Date of Birth</label>
                <span class="required-asterisk">*</span>
                <input v-model="newChild.dob" type="date" class="input-field" placeholder="Select Date of Birth"
                       :rules="{ required: true }" :max="new Date().toISOString().split('T')[0]" />
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button class="addMore-btn mt-1" @click="addChild" type="button">
                <span v-if="editingChildIndex !== null">Update</span>
                <span v-else>Add Child</span>
              </button>
            </div>
          </form>
        </div>
        <div v-if="tierType === 'IF'">
          <div v-if="dependents.length > 0" class="mb-3">
              <div v-for="(member, index) in dependents" :key="member.id"
                class="d-inline-flex me-2 align-items-center gap-2 button_wrapper--blue mb-2">
                <div class="rep_name d-inline-flex">
                  #{{ index + 1 }}
                  {{ member.firstName }}
                  <template v-if="member.middleName"> {{ member.middleName }} </template>
                  {{ member.lastName }}
                  <span class="rep_relation fw-normal">({{ member.relation }})</span>
                </div>
                <button class="tier-listing-card-button" type="button" @click="editFamilyMember(index)"><i
                    class="fa fa-pencil"></i> </button>
                <button class="tier-listing-card-button" type="button" @click="removeFamilyMember(index)"><i
                    class="fa fa-trash"></i> </button>
              </div>
          </div>
          <form class="tier-formwrapper mb-3">
            <div class="form-titlewrapper">Family Details</div>
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">First Name</label>
                <span class="required-asterisk">*</span>
                <input v-model="newFamilyMember.firstName" type="text" class="input-field" placeholder="Enter First Name"
                  :rules="{ required: true }" />
              </div>
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">Middle Name</label>
                <input v-model="newFamilyMember.middleName" type="text" class="input-field"
                  placeholder="Enter Middle Name" :rules="{ required: true }" />
              </div>
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">Last Name</label>
                <span class="required-asterisk">*</span>
                <input v-model="newFamilyMember.lastName" type="text" class="input-field" placeholder="Enter Last Name"
                  :rules="{ required: true }" />
              </div>
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">Relation</label>
                <span class="required-asterisk">*</span>
                <select v-model="newFamilyMember.relation" name="relation" id="relation" class="form-select mt-2"
                  :rules="{ required: true }">
                  <option selected disabled value="">Select Relation</option>
                  <option value="spouse" :disabled="spouses.length > 0">Spouse</option>
                  <option value="child">Child</option>
                </select>
              </div>
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">Gender</label>
                <span class="required-asterisk">*</span>
                <select v-model="newFamilyMember.gender" name="gender" id="gender" class="form-select mt-2">
                  <option selected disabled value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <div class="col-md-6 col-lg-4 mb-3">
                <label class="label-title">Date of Birth</label>
                <span class="required-asterisk">*</span>
                <input v-model="newFamilyMember.dob" type="date" class="input-field" placeholder="Select Date of Birth"
                       :rules="{ required: true }" :max="new Date().toISOString().split('T')[0]" />
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button class="addMore-btn mt-1" @click="addFamilyMember" type="button">
                <span v-if="editingFamilyMemberIndex !== null">Update</span>
                <span v-else>Add Family Member</span>
              </button>
            </div>
          </form>
        </div>
        <div>
          <label><strong>Reason </strong></label>
          <span class="required-asterisk">*</span>
          <textarea v-model="reasonText" class="form-control mt-2" rows="4" placeholder="Write a Reason"></textarea>
        </div>
        <div class="button-wrapper">
          <button type="button" class="btn cancel-btn btn-secondary" @click="closeModal">
            Cancel
          </button>
          <b-button class="univ-btn" type="submit" @click="handleSave">
            Save
          </b-button>
        </div>
      </b-container>
    </b-modal>
  </template>
  <script>
  export default {
    name: "EditMemberTierModal",
    props: {
      members: {
        type: Object,
        required: true,
      },
      policyId: {
        type: [Number, String],
        required: true,
      },
      isOpen: {
        type: Boolean,
        default: false,
      },
      existingSpouse: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        tierType: "IO",
        spouses: [],
        editingSpouse: false,
        newSpouse: {
          firstName: "",
          middleName: "",
          lastName: "",
          gender: "",
          dob: "",
          did: "",
        },
        dependents: [],
        children: [],
        newChild: {
          firstName: "",
          middleName: "",
          lastName: "",
          gender: "",
          dob: "",
          did: "",
        },
        newFamilyMember: {
          firstName: "",
          middleName: "",
          lastName: "",
          gender: "",
          dob: "",
          relation: "",
          did: "",
        },
        reasonText: "",
        modalVisible: false,
        editingChildIndex: null,
        editingFamilyMemberIndex: null,
        defaultDependents: {
          spouses: [],
          children: []
        }
      };
    },
    methods: {
      closeModal() {
        this.$bvModal.hide("editMemberTierModal");
      },
      resetForm() {
        this.newSpouse = {
          firstName: "",
          middleName: "",
          lastName: "",
          gender: "",
          dob: "",
          did: "",
        };
        this.newChild = {
          firstName: "",
          middleName: "",
          lastName: "",
          gender: "",
          dob: "",
          did: "",
        };
        this.newFamilyMember = {
          firstName: "",
          middleName: "",
          lastName: "",
          gender: "",
          dob: "",
          relation: "",
          did: ""
        };
        this.reasonText = "";
        this.editingSpouse = false;
        this.editingChildIndex = null;
        this.editingFamilyMemberIndex = null;
      },
      initializeDependents() {
        this.resetForm();
        this.spouses = [];
        this.children = [];
        this.dependents = [];
        this.defaultDependents = { spouses: [], children: [] };
  
        const dependents = this.members?.dependents || [];
        this.tierType = this.members?.plan_details?.[0]?.plan_tier || "IO";
  
        dependents.forEach((dep, index) => {
          const dependent = {
            id: dep.dependent_id || Date.now(),
            firstName: dep.d_fname || "",
            middleName: dep.d_mname || "",
            lastName: dep.d_lname || "",
            gender: dep.d_gender === "0" ? "male" : (dep.d_gender === "1" ? "female" : ""),
            dob: dep.d_dob || "",
            relation: dep.d_relate === "S" ? "spouse" : "child",
            did: dep.dependent_id || ""
          };
  
          if (dependent.relation === "spouse" && this.spouses.length === 0 && index === 0) {
            this.spouses.push({ ...dependent });
            this.defaultDependents.spouses.push({ ...dependent });
            this.newSpouse = { ...dependent };
          } else if (dependent.relation === "child") {
            this.children.push({ ...dependent });
            this.defaultDependents.children.push({ ...dependent });
          }
  
          this.dependents.push({ ...dependent });
        });
      },
      updateSpouse() {
        const { firstName, lastName, gender, dob } = this.newSpouse;
        if (firstName && lastName && gender && dob) {
          const spouseData = {
            id: this.spouses.length > 0 ? this.spouses[0].id : Date.now(),
            ...this.newSpouse
          };
          this.spouses = [spouseData];
          this.defaultDependents.spouses = [spouseData];
          if (this.tierType === "IF") {
            this.dependents = [
              { ...spouseData, relation: "spouse" },
              ...this.children.map(c => ({ ...c, relation: "child" }))
            ];
          } else if (this.tierType === "IS") {
            this.dependents = [{ ...spouseData, relation: "spouse" }];
          }
        }
        this.editingSpouse = false;
      },
      editSpouse() {
        this.editingSpouse = true;
        this.newSpouse = { ...this.spouses[0] };
      },
      removeSpouse() {
        if (confirm("Are you sure you want to delete this spouse?")) {
          this.spouses = [];
          this.defaultDependents.spouses = [];
          this.newSpouse = { firstName: "", middleName: "", lastName: "", gender: "", dob: "" };
          if (this.tierType === "IF") {
            this.dependents = this.children.map(c => ({ ...c, relation: "child" }));
          } else if (this.tierType === "IS") {
            this.dependents = [];
          }
        }
      this.editingSpouse = false;
      },
      addChild() {
        const { firstName, lastName, gender, dob } = this.newChild;
        if (!firstName || !lastName || !gender || !dob) {
          this.$notify("Please fill all required child fields.", 'error');
          return;
        }
        const childData = {
          id: this.editingChildIndex !== null ? this.children[this.editingChildIndex].id : Date.now(),
          ...this.newChild
        };
        if (this.editingChildIndex !== null) {
          this.children.splice(this.editingChildIndex, 1, childData);
          this.defaultDependents.children.splice(this.editingChildIndex, 1, childData);
          this.editingChildIndex = null;
        } else {
          this.children.push(childData);
          this.defaultDependents.children.push(childData);
        }
        this.newChild = { firstName: "", middleName: "", lastName: "", gender: "", dob: "" };
        if (this.tierType === "IF") {
          this.dependents = [
            ...this.spouses.map(s => ({ ...s, relation: "spouse" })),
            ...this.children.map(c => ({ ...c, relation: "child" }))
          ];
        }
      },
      editChild(index) {
        this.editingChildIndex = index;
        this.newChild = { ...this.children[index] };
      },
      removeChild(index) {
        if (confirm("Are you sure you want to delete this child?")) {
          this.children.splice(index, 1);
          this.defaultDependents.children.splice(index, 1);
          if (this.tierType === "IF") {
            this.dependents = [
              ...this.spouses.map(s => ({ ...s, relation: "spouse" })),
              ...this.children.map(c => ({ ...c, relation: "child" }))
            ];
          }
        }
      },
      addFamilyMember() {
        const { firstName, lastName, gender, dob, relation } = this.newFamilyMember;
        if (!firstName || !lastName || !gender || !dob || !relation) {
          this.$notify("Please fill all required fields.", 'error');
          return;
        }
        if (relation === "spouse" && this.spouses.length >= 1 && this.editingFamilyMemberIndex === null) {
          this.$notify("IF tier allows only one spouse.", 'error');
          return;
        }
        const memberData = {
          id: this.editingFamilyMemberIndex !== null ? this.dependents[this.editingFamilyMemberIndex].id : Date.now(),
          ...this.newFamilyMember
        };
        if (this.editingFamilyMemberIndex !== null) {
          this.dependents.splice(this.editingFamilyMemberIndex, 1, memberData);
          if (memberData.relation === "spouse") {
            this.defaultDependents.spouses = [memberData];
          } else {
            const childIndex = this.defaultDependents.children.findIndex(c => c.id === memberData.id);
            if (childIndex >= 0) {
              this.defaultDependents.children.splice(childIndex, 1, memberData);
            } else {
              this.defaultDependents.children.push(memberData);
            }
          }
          this.editingFamilyMemberIndex = null;
        } else {
          this.dependents.push(memberData);
          if (memberData.relation === "spouse") {
            this.defaultDependents.spouses = [memberData];
          } else {
            this.defaultDependents.children.push(memberData);
          }
        }
        this.spouses = this.dependents.filter(d => d.relation === "spouse").slice(0, 1);
        this.children = this.dependents.filter(d => d.relation === "child");
        this.newFamilyMember = {
          firstName: "",
          middleName: "",
          lastName: "",
          gender: "",
          dob: "",
          relation: "",
          did: ""
        };
      },
      editFamilyMember(index) {
        this.editingFamilyMemberIndex = index;
        this.newFamilyMember = { 
          ...this.dependents[index],
          did: this.dependents[index].did
        };
      },
      removeFamilyMember(index) {
        if (confirm("Are you sure you want to delete this family member?")) {
          const removedMember = this.dependents[index];
          this.dependents.splice(index, 1);
          this.spouses = this.dependents.filter(d => d.relation === "spouse").slice(0, 1);
          this.children = this.dependents.filter(d => d.relation === "child");
          if (removedMember.relation === "spouse") {
            this.defaultDependents.spouses = [];
          } else {
            const childIndex = this.defaultDependents.children.findIndex(c => c.id === removedMember.id);
            if (childIndex >= 0) {
              this.defaultDependents.children.splice(childIndex, 1);
            }
          }
        }
      },
      validateTierDependents(tier, dependents) {
        const errors = [];
        const spouseCount = dependents.filter(d => d.relation === "S").length;
        const childCount = dependents.filter(d => d.relation === "C").length;
  
        switch (tier) {
          case "IO":
            if (dependents.length > 0) {
              this.$notify('IO tier cannot have dependents.', 'error');
            }
            break;
          case "IS":
            if (spouseCount !== 1) {
              this.$notify("IS tier requires exactly 1 spouse.", 'error');
            }
            if (childCount > 0) {
              this.$notify("IS tier cannot have children.", 'error');
            }
            break;
          case "IC":
            if (childCount < 1) {
              this.$notify("IC tier requires at least 1 child.", 'error');
            }
            if (spouseCount > 0) {
              this.$notify("IC tier cannot have a spouse.", 'error');
            }
            break;
          case "IF":
            if (spouseCount !== 1) {
              this.$notify("IF tier requires exactly 1 spouse.", 'error');
            }
            if (childCount < 1) {
              this.$notify("IF tier requires at least 1 child.", "error");
            }
            break;
        }
        return errors;
      },
      prepareDependents() {
        const dependents = [];
  
        if (this.tierType === "IS") {
          if (this.spouses.length > 0) {
            this.spouses.forEach(spouse => {
              if (spouse.firstName && spouse.lastName && spouse.gender && spouse.dob) {
                dependents.push({
                  first_name: spouse.firstName,
                  middle_name: spouse.middleName || "",
                  last_name: spouse.lastName,
                  relation: "S",
                  gender: spouse.gender === "male" ? "0" : "1",
                  dob: spouse.dob,
                  did: spouse.did || "",
                  ssn: "",
                });
              }
            });
          } else if (this.newSpouse.firstName && this.newSpouse.lastName && this.newSpouse.gender && this.newSpouse.dob) {
            dependents.push({
              first_name: this.newSpouse.firstName,
              middle_name: this.newSpouse.middleName || "",
              last_name: this.newSpouse.lastName,
              relation: "S",
              gender: this.newSpouse.gender === "male" ? "0" : "1",
              dob: this.newSpouse.dob,
              did: this.newSpouse.did || "",
              ssn: "",
            });
          }
        }
  
        if (this.tierType === "IC") {
          this.children.forEach(child => {
            if (child.firstName && child.lastName && child.gender && child.dob) {
              dependents.push({
                first_name: child.firstName,
                middle_name: child.middleName || "",
                last_name: child.lastName,
                relation: "C",
                gender: child.gender === "male" ? "0" : "1",
                dob: child.dob,
                did: child.did || "",
                ssn: ""
              });
            }
          });
        }
  
        if (this.tierType === "IF") {
          this.dependents.forEach(member => {
            if (member.firstName && member.lastName && member.gender && member.dob) {
              dependents.push({
                first_name: member.firstName,
                middle_name: member.middleName || "",
                last_name: member.lastName,
                relation: member.relation === "spouse" ? "S" : "C",
                gender: member.gender === "male" ? "0" : "1",
                dob: member.dob,
                did: member.did || "",
                ssn: ""
              });
            }
          });
        }
  
        return dependents;
      },
      handleSave() {
        if (this.tierType === "IS") {
          this.updateSpouse();
        }
        const dependents = this.prepareDependents();
        const errors = this.validateTierDependents(this.tierType, dependents);
  
        if (errors.length) {
          this.$notify(errors.join("\n"), 'error');
          return;
        }
  
        if (!this.reasonText) {
          this.$notify("Please enter a reason.", 'error');
          return;
        }
  
        const payload = {
          policy_id: this.policyId,
          new_tier: this.tierType,
          reason: this.reasonText,
          comments: this.reasonText,
          dependents: dependents
        };
  
        this.$emit("saveTier", payload);
      }
    },
    watch: {
      isOpen(newVal) {
        this.modalVisible = newVal;
        if (newVal) {
          this.initializeDependents();
        } else {
          this.resetForm();
        }
      },
      modalVisible(newVal) {
        if (!newVal) {
          this.$emit("onCloseModal");
        }
      },
      tierType(newVal) {
        if (newVal === "IF") {
          this.spouses = [...this.defaultDependents.spouses];
          this.children = [...this.defaultDependents.children];
          this.dependents = [
            ...this.spouses.map(s => ({ ...s, relation: "spouse" })),
            ...this.children.map(c => ({ ...c, relation: "child" }))
          ];
          this.newSpouse = this.spouses.length > 0 ? { ...this.spouses[0] } : {
            firstName: "",
            middleName: "",
            lastName: "",
            gender: "",
            dob: ""
          };
        } else if (newVal === "IS") {
          this.spouses = [...this.defaultDependents.spouses];
          this.children = [];
          this.dependents = this.spouses.map(s => ({ ...s, relation: "spouse" }));
          this.newSpouse = this.spouses.length > 0 ? { ...this.spouses[0] } : {
            firstName: "",
            middleName: "",
            lastName: "",
            gender: "",
            dob: ""
          };
          this.editingSpouse = false;
        } else if (newVal === "IC") {
          this.spouses = [];
          this.children = [...this.defaultDependents.children];
          this.dependents = this.children.map(c => ({ ...c, relation: "child" }));
          this.newSpouse = { firstName: "", middleName: "", lastName: "", gender: "", dob: "" };
        } else if (newVal === "IO") {
          this.spouses = [];
          this.children = [];
          this.dependents = [];
          this.newSpouse = { firstName: "", middleName: "", lastName: "", gender: "", dob: "" };
        }
      },
      newSpouse: {
        handler() {
          if (this.tierType === "IS" && this.spouses.length === 0) {
            this.updateSpouse();
          }
        },
        deep: true
      }
    }
  };
  </script>
  <style scoped>
  .tier-listing-card-button {
    background-color: transparent !important;
    border: none;
  }
  
  .btn-container {
      cursor: pointer;
  }
  
  .button-wrapper {
      display: flex;
      justify-content: right;
      margin-top: 24px;
      gap: 16px;
      align-items: center;
  }
  
  .univ-btn,
  .cancel-btn {
      padding: 10px 26px;
      width: fit-content;
      font-size: 14px;
      margin: 0;
  }
  
  .form-select,
  .form-control {
      font-size: 14px;
      padding: 9px 15px;
      border: 1px solid #dce1e7;
      border-radius: 6px;
  }
  
  .form-select:focus,
  .form-control:focus,
  .form-check-input:focus {
      outline: none;
      box-shadow: none;
      border: 1px solid #dce1e7;
  }
  
  .tier-optionwrapper .form-check-input:checked {
      background-color: #03c3ec;
      border-color: #03c3ec;
  }
  
  .tier-formwrapper {
      background-color: #f7fafc;
      padding: 20px;
      border-radius: 6px;
  }
  
  .form-titlewrapper {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 16px;
  }
  
  .mx-input {
      padding: 9px 15px !important;
  }
  
  .mx-datepicker {
      width: 100%;
  }
  
  .addMore-btn {
      background-color: rgba(3, 195, 236, 0.1);
      border: 1px solid #03c3ec;
      color: #03c3ec;
      font-size: 14px;
      padding: 8px 18px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      gap: 6px;
      font-weight: 500;
  }
  
  .button_wrapper--blue {
      border: 1px solid #03c3ec;
      background-color: #03c3ec;
      color: #fff;
      padding: 8px 16px;
      border-radius: 6px;
      font-size: 14px;
  }
  
  .button_wrapper--blue a {
      color: #fff;
      text-decoration: none;
  }
  
  .rep_name {
      font-weight: 500;
  }
  </style>